import React from "react";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import AuthProvider from "../../auth/AuthProvider";
import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";

function ShortlinkForm() {
  return (
    <AuthProvider prefix={"shortlinks"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          return formatTitle(this.pageTitle, model.shortlink);
        }}
        endPoint={"core/shortlinks"}
        pageTitle={getTranslation("shortlinks.form.pageTitle", "Shortlinks")}
        pageTitleSubject={function (model) {
          return (
            <small>
              <Link to={`/manager/vestigingen/${model.vestiging?.id}/edit`}>{model.vestiging?.naam}</Link> -{" "}
              {model.vestiging?.id}
            </small>
          );
        }}
        tabs={[
          {
            right: "algemeen",
            tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"shortlinks.form.tabs.algemeen"} />,
            tabContent: <Algemeen />,
          },
        ]}
      />
    </AuthProvider>
  );
}

export default ShortlinkForm;
